const debugar = false ; 
const URL = 'https://beta.ges.services'
//const URL ='http://localhost:3000'
//const URL = 'https://ubiku.ges.services'
//const URL = 'https://beta-madrid.ges.services'

const arranque = '/home'
/** 
 * Mecanismo de inclusion de rutas de grabacion  filtradas por tipo de usuario  
 * */

const rutas_capadas = new RegExp(/^\/(xxxxxx)/ig)
//const rutas_geoloc = new RegExp(/^\/(eliminar_ubicacion|actualizar_ubicaciones|set_recepcion|set_entrada|update_envio|update_recepcion)/ig)


    export const myURL= URL;
    import { createApp } from 'vue'
    import App from './App.vue'
    import router from './router';
    import { IonicVue} from '@ionic/vue';
    import { Device } from "@capacitor/device";
    import { openToast} from  '@/utilities/services/alert-utilities';
    import {  openAlertaV2 } from  '@/utilities/services/alert-utilities';
    import { defineCustomElements } from '@ionic/pwa-elements/loader'; 
    import eventBus from "@/event-bus";
    import { globalFilters } from './utilities/filters'
    import { loadStorage,  limpiarMemoria } from '@/utilities/storage/storage-utilities-main'
    import { Camera } from '@capacitor/camera';
    import { Geolocation } from '@capacitor/geolocation';
    import AppTypeahead from "./components/filtros/AppTypeahead.vue";
    
    // Importar Sentry para monitoreo de errores
    import * as Sentry from '@sentry/vue';

/* 
  
  Importamos los componente de Ionic que utilizaremos 
  los exponemos desde aqui al resto de la app 
  con un app.compononent... 
 */

import {    
  IonBadge, IonButton, IonButtons, 
  IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCardSubtitle,
  IonCol,
  IonCheckbox,
  IonContent,
  IonFab, IonFabButton,IonFabList, 
  IonGrid,
  IonFooter,
  IonHeader,
  IonIcon,
  IonImg,
  IonInfiniteScroll, IonInfiniteScrollContent,
  IonInput, 
  IonDatetime, 
  IonPicker, 
  IonRadio, IonRadioGroup, 
  IonItem, IonItemDivider, IonItemSliding, IonItemOption, IonItemOptions,
  IonLabel,
  IonList, IonListHeader,
  IonModal,
  IonNav,
  IonNote,
  IonPage,
  IonProgressBar, 
  IonReorder, IonReorderGroup, 
  IonRow,
  IonSearchbar,
  IonSegment, IonSegmentButton,
  IonSelect, IonSelectOption,
  IonSpinner,
  IonTabs, IonTabBar, IonTabButton, 
  IonThumbnail,
  IonText,
  IonTitle,
  IonToggle,
  IonToolbar,

 } from '@ionic/vue';


/** Wijmo components */
  //import { registerCore } from '@grapecity/wijmo.vue2.core';
  import { registerBarcodeCommon } from '@grapecity/wijmo.vue2.barcode.common';
 // apply Wijmo license key (if you have one)  
 import { setLicenseKey } from '@grapecity//wijmo';  
 setLicenseKey('beta.ges.digital|ubiku.ges.digital,288251898349353#B0vyimdiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34TQvJmVi36Sp9GZxEFd8EGNPlDUG9kSkRDVE9WcOhGc5x6bzQnTRVHRIdEaXRVT0VnbxU7QENnYxNVOwckcWtSeHB7b5FTRSFlM99mTXdjcXNlcwtSWtd7UEJGboFkdoRlMURzLzl4aWZUWy2WcH3GSYF4biNETPF6MFNVbIdFRvkXV9UVU8JGTMp5ZqBTdzYEOiRDaahTZwZkaQRzN8MDURFnYQl6VhFjWwVDSopGMmR5VkRVTzcUWwQzLDtyRiJVdwI4VXtSUXJzM4djTiVUQ054avAlMBpWcZdHOrhFbCZzR8ljd9kTZEFTM5UHTBl6UZpFa0Fmb5J4RCp4Z58EWyRlU9xWQ0Zma6kUbYVnYxoFdmZncHZVSHhFdDdFekRUWvIFR8t6QONWa7gUMkdWcQ94Uyo5axwkZRN7RPZkSK9WOrgDVNVDcStGaLFXOq3UWTZzcw5kI0IyUiwiIBhDM5YUO6IjI0ICSiwCM9EDO7YTOyQTM0IicfJye&Qf35VfikEMyIlI0IyQiwiIu3Waz9WZ4hXRgACdlVGaThXZsZEIv5mapdlI0IiTisHL3JSNJ9UUiojIDJCLi86bpNnblRHeFBCIyV6dllmV4J7bwVmUg2Wbql6ViojIOJyes4nILdDOIJiOiMkIsIibvl6cuVGd8VEIgc7bSlGdsVXTg2Wbql6ViojIOJyes4nI4YkNEJiOiMkIsIibvl6cuVGd8VEIgAVQM3EIg2Wbql6ViojIOJyes4nIzMEMCJiOiMkIsISZy36Qg2Wbql6ViojIOJyes4nIVhzNBJiOiMkIsIibvl6cuVGd8VEIgQnchh6QsFWaj9WYulmRg2Wbql6ViojIOJyebpjIkJHUiwiI4EzNwUDMgIDM5AzMyAjMiojI4J7QiwiIsFGdpdWak9ycldmL5tWaiVHLsFGdpdWak9ycldmLhRXZiJiOiMXbEJCLiM7aj3GdTBybyR7YlxWRg2Gc5J7RiojIh94QiwiIzUzM9QzM8kDOxUjM8gjMiojIklkIs4XXbpjInxmZiwiIxYnMyAjOimj');  
 

/* Importamos y configuramos axios */
    import axios from 'axios';
    axios.defaults.baseURL = URL;
    axios.defaults.headers["Content-Type"] = "application/json"
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    axios.defaults.headers["Access-Control-Allow-Origin"] = "*"
    axios.mode = "no-cors"
    

/** Version 8.2.6  */
    import firebase from 'firebase/app';
    import 'firebase/auth';


     firebase.initializeApp({
        apiKey: "AIzaSyAzwMsPdcrIbVEvqrqopkjpOLG2Vm3PjGA",
        authDomain: "appgescom.firebaseapp.com",
        projectId: "appgescom",
        storageBucket: "appgescom.appspot.com",
        messagingSenderId: "728244704694",
        appId: "1:728244704694:web:ced2e56799f4abb42a1d17",
        measurementId: "G-KX4GNXBZ0Q",
        databaseURL: "https://appgescom.firebaseio.com"
      });


    /* Core CSS required for Ionic components to work properly */
    import '@ionic/vue/css/core.css';
    /* Basic CSS for apps built with Ionic */
    import '@ionic/vue/css/normalize.css';
    import '@ionic/vue/css/structure.css';
    import '@ionic/vue/css/typography.css';
    /* Optional CSS utils that can be commented out */
    import '@ionic/vue/css/padding.css';
    import '@ionic/vue/css/float-elements.css';
    import '@ionic/vue/css/text-alignment.css';
    import '@ionic/vue/css/text-transformation.css';
    import '@ionic/vue/css/flex-utils.css';
    import '@ionic/vue/css/display.css';

    import 'purecss/build/pure.css';

    /* Theme variables */
    import './theme/variables.css';
    import './registerServiceWorker'
    
    /* Funciones generales */
    window.miconsola =  debugar === true ? console.log : function() {void(0)}
    window.fake_console =  debugar === true ? console.log : function() {void(0)}
    window.fake_console('Paso por MAIN ')
    

/** 
 * Inicializamos la app 
 * 
 * 
 * */

    let app = createApp(App)
          .use(IonicVue)
          .use(router);

    // Version y enviroment de sentry
    console.info('Version Sentry: ' + process.env.VUE_APP_SENTRY_RELEASE);
    console.info('Enviroment: ' + process.env.VUE_APP_SENTRY_ENVIRONMENT);

    // Configurar Sentry para monitoreo de errores
    Sentry.init({
        app,
        dsn: process.env.VUE_APP_SENTRY_DSN,
        environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || 'production',
        release: process.env.VUE_APP_SENTRY_RELEASE || '0.2.0',
        integrations: [
            // Integración con Vue Router para rastreo de navegación
            Sentry.browserTracingIntegration({ router }),
            // Integración con Vue para capturar errores de componentes
            Sentry.vueIntegration({
                tracingOptions: {
                    trackComponents: true,
                    timeout: 2000,
                    hooks: ['mount', 'update', 'unmount'],
                },
            }),
        ],
        // Configuración de muestreo de rendimiento
        tracesSampleRate: debugar ? 1.0 : 0.1,
        // Configuración de captura de errores
        beforeSend(event, hint) {
            // Filtrar errores en desarrollo si debugar está activado
            if (debugar) {
                console.log('Sentry Event:', event, hint);
            }
            return event;
        },
        // Configurar información del usuario
        initialScope: {
            tags: {
                component: 'ubiku-ges-ios',
                platform: 'pwa'
            }
        }
    });

    window.Sentry = Sentry;
          
/* Creamos los componentes globales para que sean accesibles */          
  
  app.component('ion-progress-bar', IonProgressBar);
  app.component('ion-badge', IonBadge);
  app.component('ion-button', IonButton);
  app.component('ion-buttons', IonButtons);
  app.component('ion-card', IonCard);
  app.component('ion-card-content', IonCardContent);
  app.component('ion-card-header', IonCardHeader);
  app.component('ion-card-title', IonCardTitle);
  app.component('ion-card-subtitle', IonCardSubtitle);
  app.component('ion-checkbox', IonCheckbox);
  app.component('ion-col', IonCol);
  app.component('ion-content', IonContent);
  app.component('ion-fab', IonFab);
  app.component('ion-fab-list', IonFabList);
  app.component('ion-fab-button', IonFabButton);
  app.component('ion-grid', IonGrid);
  app.component('ion-footer', IonFooter);
  app.component('ion-header', IonHeader);
  app.component('ion-icon', IonIcon);
  app.component('ion-img', IonImg);
  app.component('ion-input', IonInput);

  app.component('ion-datetime', IonDatetime);
  app.component('ion-picker', IonPicker);

  app.component('ion-infinite-scroll', IonInfiniteScroll);
  app.component('ion-infinite-scroll-content', IonInfiniteScrollContent);
  app.component('ion-item', IonItem);
  app.component('ion-item-divider', IonItemDivider);
  app.component('ion-item-sliding', IonItemSliding); 
  app.component('ion-item-options', IonItemOptions);
  app.component('ion-item-option', IonItemOption);
  app.component('ion-label', IonLabel);
  app.component('ion-list', IonList);
  app.component('ion-list-header', IonListHeader);
  app.component('ion-modal', IonModal);
  app.component('ion-nav', IonNav);
  app.component('ion-note', IonNote);
  app.component('ion-page', IonPage);
  app.component('ion-radio', IonRadio)
  app.component('ion-radio-group', IonRadioGroup)
  app.component('ion-reorder-group', IonReorderGroup)
  app.component('ion-reorder', IonReorder)
  app.component('ion-row', IonRow);
  app.component('ion-searchbar', IonSearchbar);
  app.component('ion-segment', IonSegment);
  app.component('ion-segment-button', IonSegmentButton);
  app.component('ion-select', IonSelect);
  app.component('ion-select-option', IonSelectOption);
  app.component('ion-spinner', IonSpinner);  
  app.component('ion-tabs', IonTabs);
  app.component('ion-tab-bar', IonTabBar);
  app.component('ion-tab-button', IonTabButton);
  app.component('ion-thumbnail', IonThumbnail);
  app.component('ion-text', IonText);
  app.component('ion-title', IonTitle);
  app.component('ion-toggle', IonToggle);
  app.component('ion-toolbar', IonToolbar);

      
  app.component('app-typeahead', AppTypeahead);

/* Añadimos los componentes de wijmo necesarios para uso general */
/** 
    Wijmo Barcodes y Qrs 
    registerBarcodeCommon(app);
    registerCore(app)
    */
    registerBarcodeCommon(app);    


/**
 * Creamos las Variables globales 
 */
    var self = app.config.globalProperties
    self.$http = axios;
    self.$filters = globalFilters
    self.$ruta_imagen =  'https://storage.googleapis.com/mobigescom/';
    self.$home = arranque 
    self.$firebase = firebase
    self.$logged = false 
    
    // Función global para configurar Sentry con información del usuario
    self.$setSentryUser = function(userData) {
			Sentry.setUser({
				id: userData.id || userData.usuario_id,
				email: userData.email || userData.correo,
				username: userData.username || userData.usuario,
				pdv: userData.pdv,
				wn: userData.wn,
				ip_address: '{{auto}}'
			});
			
			Sentry.setTag('user_role', userData.rol || 'unknown');
			Sentry.setTag('company', userData.empresa || 'unknown');
    }; 


/** Listener para deeplinks */    
eventBus().emitter.on('new-deeplink',(new_deeplink) => {
    self.$deeplink = new_deeplink; 
    window.fake_console('oido cocina : ', self.$deeplink)
})
    


const interceptores = async function(self, be) {
    window.fake_console('Monto los interceptores')
    window.fake_console(self.$pdv , self.$router.currentRoute)
    self.$http.defaults.headers['key'] = be
    self.$http.interceptors.request.use(req => {
        if (rutas_capadas.test(req.url) ) {
            openAlertaV2('No autorizado', 'Peticion no autorizada para tu perfil.... ')
            self.$router.replace('/home')
            return req
        }
        else 
        {
            req.params = req.params || {};
            req.params['dev'] = self.$deviceUuid;
            req.params['ml'] = self.$current_user;
            req.params['wn'] = self.$wnumber ?? '';
            return req; 
        }

    })
    self.$http.interceptors.response.use(
        res=> {
                if (!res) return Promise.reject({ message: 'Empty response in interceptor', isBusinessError: false });
                const url = res.config?.url || '';
                const isAuth = /^\/(check|login|logout|apex)/i.test(url);
                if (!res.data || res.data.status_log === false ){
                    if (isAuth) {
                        self.$logged = false;
                        window.fake_console(self.$router.currentRoute, self.$deeplink)
                        self.$router.replace('/login')
                        return false
                    }
                    return Promise.reject({ isBusinessError: true, response: res });
                }
                return res
            }, 
        error => {
            // Estos errores ya fueron manejados en el interceptor de respuestas y no son errores técnicos
            if (error && error.isBusinessError) {
                return Promise.reject(error);
            }
            
            Sentry.captureException(error, {
                tags: {
                    errorType: 'http_error',
                    url: error.config?.url,
                    method: error.config?.method
                },
                extra: {
                    status: error.response?.status,
                    statusText: error.response?.statusText,
                    data: error.response?.data
                }
            });
            
            if(error.response?.status === 404 ) {
                window.fake_console('Estoy en el error del undefined, pasaremos por login  ')
                self.$logged = false;
                self.$router.replace('/login')
                return false
            }
        }
    )   
    return 1
}




    /** Modelo persistencia optimizado (Paralelo) */
    const persist= async function(self) {
        const entroTT = Date.now()
        window.fake_console(`Entro el funcion persist : ${entroTT}`)
        try {
                await limpiarMemoria(self.$pdv)
                window.fake_console(`Inicio recuperacion de datos paralela, llevo  ${Date.now()-entroTT} ms`) 
                openToast('Cargando datos...', `Cargando en memoria los datos del pdv : ${self.$pdv}`, 2500)
                
                const googleBtn = document.getElementById("google-login-btn");
                const microsoftBtn = document.getElementById("microsoft-login-btn");
                if (googleBtn) googleBtn.setAttribute("disabled", "true");
                if (microsoftBtn) microsoftBtn.setAttribute("disabled", "true");

                // Definimos las promesas para ejecución en paralelo
                const promises = [
                    self.$http.post(`/eans_pdv/${self.$pdv}`),           // 0
                    self.$http.post(`/ubicaciones_pdv/${self.$pdv}`),    // 1
                    self.$http.post(`/catalogo_pdv/${self.$pdv}`),       // 2
                    self.$http.post(`/lotes_pdv/${self.$pdv}`),          // 3
                    self.$http.post(`/bobinas/${self.$pdv}`),            // 4
                    self.$http.post(`/get_supplier_coils/${self.$pdv}`), // 5
                    self.$http.post(`/get_clientes_pdv/${self.$pdv}`)    // 6
                ];

                const results = await Promise.all(promises);

                const [
                    eans_pdv, 
                    ubicaciones_pdv, 
                    catalogo_pdv, 
                    lotes_pdv, 
                    bobinas_pdv, 
                    codigos_bobinas, 
                    clientes_pdv
                ] = results;

                window.fake_console(`Todos los datos recuperados, llevo  ${Date.now()-entroTT} ms`)
                
                // Logging de muestras como en el original (opcional, para debug)
                if (debugar) {
                    window.fake_console('Eans:', JSON.stringify(eans_pdv.data).slice(0,50))
                    window.fake_console('Ubicaciones:', JSON.stringify(ubicaciones_pdv.data).slice(0,50))
                    window.fake_console('Catalogo:', JSON.stringify(catalogo_pdv.data).slice(0,50))
                    window.fake_console('Lotes:', JSON.stringify(lotes_pdv.data).slice(0,50))
                }

                self.$ubicaciones_pdv = ubicaciones_pdv.data

                eventBus().emitter.emit('memory-data', {
                        eans_pdv: eans_pdv.data, ubicaciones_pdv: ubicaciones_pdv.data, 
                        catalogo_pdv: catalogo_pdv.data, lotes_pdv :lotes_pdv.data , 
                        pdv: self.$pdv , nompos: self.$nompos , 
                        ubiku_recepcion: self.$ubiku_recepcion , 
                        pdv_geoloc : self.$pdv_geoloc, 
                        bobinas_pdv : bobinas_pdv.data, 
                        codigos_bobinas : codigos_bobinas.data,  
                        clientes_pdv : clientes_pdv.data, 
                        isIOS : self.$isIOS , logged: true, 
                        ubiku_rol : self.$ubiku_rol, 
                        racrol : self.$racrol,
                        mis_pdvs : self.$mis_pdvs

                    })
                self.$logged = true;
                try {
                    await self.$firebase.auth().signOut()
                    window.fake_console('consigo el logout de firebase')
                    }
                catch  {
                    window.fake_console('imposible el logout ')
                }
                window.fake_console(self.$deeplink , self.$home)
                const destino =  ( self.$deeplink !=undefined && self.$deeplink != '/login') ? self.$deeplink : self.$home
                window.fake_console(destino)
                const hasParams = destino.indexOf('?')!=-1
                window.fake_console(`Salgo funcion persist -sin mandar a login-, he tardado ${Date.now()-entroTT} ms, voy a ${destino}`)
                const u = `${destino}${hasParams ? '&' : '?'}q=${Date.now()}`
                window.fake_console(u)
                
                if (googleBtn) googleBtn.removeAttribute("disabled");
                if (microsoftBtn) microsoftBtn.removeAttribute("disabled");

                self.$router.replace(u)   
            }
        catch (ex) 
            {
                console.log(`Salgo funcion persist -enviando a LOGIN-, he tardado ${new Date()-entroTT} seg: ${ex}`)
                
                const googleBtn = document.getElementById("google-login-btn");
                const microsoftBtn = document.getElementById("microsoft-login-btn");
                
                if (googleBtn) {
                    googleBtn.removeAttribute("disabled");
                }
                if (microsoftBtn) {
                    microsoftBtn.removeAttribute("disabled"); 
                }

                self.$router.replace('/login')
            }
    };
    
/**  Cargamos las variables de entorno
 * Se hacia con cada navegacion!!!!!
 * Lo desplazamos a app.create o cambios en login 
*/
const procesoInicial = async (desde) => {
    window.fake_console('DESDE DONDE :', desde)
    const d = new Date()
    window.fake_console(`${d} : Inicio Proceso Inicial desde ${desde}`)
    const res = await Device.getId();
    self.$deviceUuid = res.uuid;
    const info = await Device.getInfo();
    self.$isIOS = (info.operatingSystem||'').toLocaleLowerCase() === 'ios'
    const be = await loadStorage('sales-plus');
    self.$pdv = await loadStorage('pdv');
    self.$nompos = await loadStorage('nompos');
    self.$ubiku_recepcion = await loadStorage('ubiku_recepcion');
    self.$pdv_geoloc = await loadStorage('pdv_geoloc');
    self.$current_user = await loadStorage('ml');
    self.$current_user_name = await loadStorage('uname');
    self.$geofence = await loadStorage('geofence');
    self.$ubiku_rol = await loadStorage('ubiku_rol');
    self.$racrol = await loadStorage('racrol');
    self.$mis_pdvs = await loadStorage('mis_pdvs');
    self.$wnumber = await loadStorage('wn');
    window.fake_console(self.$pdv, self.$isIOS)
    eventBus().emitter.emit('deeplink-log', { pdv: self.$pdv   ,  isIOS : self.$isIOS , 
            logged: self.$logged, nompos: self.$nompos , 
            ubiku_recepcion: self.$ubiku_recepcion, 
            pdv_geoloc : self.$pdv_geoloc   
        })
    await interceptores(self, be) 
    const chequer = await self.$http.post(`/check/${self.$pdv}`)
    window.fake_console(chequer)
    if (chequer) {
        const d = chequer.data
        if (d.racrol === 0 && self.$pdv !=d.pdv_principal){
            window.fake_console({racrol: d.racrol, pdv: self.$pdv, pdv_principal : d.pdv_principal })
            window.fake_console({name : 'login',  params : { forzar_pdv : d.pdv_principal }})
            self.$router.replace({name : 'login',  params : { forzar_pdv : d.pdv_principal }})
            
        }
        else {
            console.log('Main 374 : ', 'estoy "persitiendo"')
            persist(self, be)    
        }
    }
}

export {procesoInicial};

/*procesoInicial('MAIN')*/


window.addEventListener("load", function() {
    /** Intento anular boton */
    document.addEventListener("backbutton", function(){}, false);

    self.$NoBackNavigator = function () {
        try {
            const st = history.state;
            history.replaceState(st, document.title, location.href);
            window.addEventListener('popstate', function () {
                const curr = history.state;
                history.replaceState(curr, document.title, location.href);
            });
        } catch (e) { /* noop */ }
    }
  });

  

router.isReady().then(async () => {
    await procesoInicial('New MAIN');
    window.fake_console('dentro del router ready')
    app.mount('#app');  
    window.fake_console('main ','App montada')
    defineCustomElements(window);
    const permisos = await Camera.checkPermissions()
    const permisosGeo = await Geolocation.checkPermissions()
    //window.fake_console(permisos)
    if (!permisos) {await Camera.requestPermissions('camera')}
  
    if (!permisosGeo) {await Geolocation.requestPermissions('camera')}



    
});
 

/** Variables globales que se utilizan en el comportamiento de la app */
eventBus().emitter.on('user-logged',async (roles, pdv_actual, nompos_actual , ubiku_recepcion, pdv_geoloc)=>{ 
  window.fake_console('en la funcion emit.on de user-logged')
  window.fake_console(roles)
  
  // Configurar Sentry con información del usuario autenticado
	if (roles && roles.usr) {
		const userEmail = `${roles.usr}@grupoelectrostocks.com`;
		
		self.$setSentryUser({
			id: roles.usr,
			username: roles.uname,
			email: userEmail,
			pdv: roles.pdv || '000',
			wn: roles.wnumber
		});

		console.log('Usuario configurado en Sentry:', roles.usr, 'Email:', userEmail);
	}
  
  //window.fake_console(roles)
  self.$current_user = roles.usr
  self.$current_user_name = roles.uname
  self.$geofence = roles.geofence
  self.$ubiku_rol = roles.ubiku_rol 
  self.$racrol = roles.racrol
  self.$mis_pdvs = roles.pdv||'000'
  self.$pdv = pdv_actual 
  self.$ubiku_recepcion = ubiku_recepcion 
  self.$pdv_geoloc = pdv_geoloc 
  self.$nompos = nompos_actual
  self.$wnumber = roles.wnumber
  procesoInicial('Login')
});

